import * as api from '@gitbook/api-client';
import type { MeterPrice } from '@gitbook/app-pricing';
import { formatChartNumber, intlPluralizeString } from '@gitbook/spine-react';

/**
 * Return the interval-aware price and correctly pluralized unit labels for usage add-on copy.
 */
export function getBillingUsageAddonPricingParts(params: {
    meterPrice: MeterPrice;
    interval: api.BillingInterval;
}): {
    flatInitialPrice: number;
    flatInitialMonthlyPrice: number;
    pricePerBatch: number;
    included: {
        count: string;
        unitLabel: string;
    };
    additional: {
        count: string | null;
        unitLabel: string;
    };
} {
    const { meterPrice, interval } = params;
    const intervalFactor = interval === api.BillingInterval.Monthly ? 1 : 12;

    return {
        flatInitialPrice: meterPrice.flatInitialPrice[interval],
        flatInitialMonthlyPrice: meterPrice.flatInitialPrice[interval] / intervalFactor,
        pricePerBatch: meterPrice.pricePerBatch,
        included: {
            count: formatChartNumber(meterPrice.startingAt),
            unitLabel: intlPluralizeString({
                count: meterPrice.startingAt,
                singular: meterPrice.unitLabels.singular.short,
                plural: meterPrice.unitLabels.plural.short,
            }),
        },
        additional: {
            count:
                meterPrice.unitsPerBatch > 1 ? formatChartNumber(meterPrice.unitsPerBatch) : null,
            unitLabel: intlPluralizeString({
                count: meterPrice.unitsPerBatch,
                singular: meterPrice.unitLabels.singular.short,
                plural: meterPrice.unitLabels.plural.short,
            }),
        },
    };
}
